module.exports = __webpack_public_path__ + "Icono_PerfilMenu_126px.png";